import RequestBase from '../Resources/RequestBase';

export default class CreateAccountRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/Accounts';
        this.method = 'POST';
        this.test = true;
        this.success = success;
        this.error = 'Wrong parameters';
        this.data = {
            data: {
                accountId: 1
            }
        };

    }
}



// WEBPACK FOOTER //
// ./src/TestResources/Accounts.js